$bog_ui_sidebar $mol_view
	mode? \dock
	items /
	sub /
		<= Header $mol_view
			sub /
		<= Items $mol_list
			rows <= items_with_collapsed /
		<= Footer $mol_view
			sub /
		<= Toggle $mol_button_minor
			click? <=> toggle? null
			sub /
				<= Toggle_icon $mol_icon_menu
	attr *
		bog_ui_sidebar_mode <= mode?
